export * from './device-register.service';